import React, {useState} from "react";
import { Table } from "antd";
import { useSelector } from "react-redux";
import _ from "lodash";
import "../../../../components/common/bt.css";

const FixedAssetBalanceTable = ({ printMode = false }) => {
  const { list, total_balance, loading } = useSelector(
    (state) => state.fixedAssetBalance
  );
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  });

  const handleTableChange = (pagination) => {
    setPagination(pagination);
  };

  const columns = [
    { title: "No.", render: (_, __, index) => index + 1, width: 60 },
    { title: "Account Name", dataIndex: "acc_name" },
    { title: "Opening Balance", dataIndex: "opening_balance", align: "right" },
    { title: "Asset Amount", dataIndex: "payment_total", align: "right" },
    { title: " Depreciation / Disposal", dataIndex: "received_total", align: "right" },
    { title: "Balance", dataIndex: "balance", align: "right" },
  ];

  if (printMode) {
  const openingTotal = _.sumBy(
    list,
    (row) => Number(row.opening_balance) || 0
  );

  const assetTotal = _.sumBy(
    list,
    (row) => Number(row.payment_total) || 0
  );

  const depreciationTotal = _.sumBy(
    list,
    (row) => Number(row.received_total) || 0
  );

  return (
    <table className="ledger-print-table">
      <colgroup>
        <col style={{ width: "6%" }} />
        <col style={{ width: "26%" }} />
        <col style={{ width: "17%" }} />
        <col style={{ width: "17%" }} />
        <col style={{ width: "17%" }} />
        <col style={{ width: "17%" }} />
      </colgroup>
      <tbody>
        <tr className="ledger-print-heading">
          <td>No.</td>
          <td>Account Name</td>
          <td style={{ textAlign: "right" }}>Opening Balance</td>
          <td style={{ textAlign: "right" }}>Asset Amount</td>
          <td style={{ textAlign: "right" }}>Depreciation / Disposal</td>
          <td style={{ textAlign: "right" }}>Balance</td>
        </tr>

        {list.map((row, index) => (
          <tr key={row.acc_id || index}>
            <td>{index + 1}</td>
            <td>{row.acc_name}</td>

            <td style={{ textAlign: "right" }}>
              {Number(row.opening_balance || 0).toFixed(2)}
            </td>

            <td style={{ textAlign: "right" }}>
              {Number(row.payment_total || 0).toFixed(2)}
            </td>

            <td style={{ textAlign: "right" }}>
              {Number(row.received_total || 0).toFixed(2)}
            </td>

            <td style={{ textAlign: "right" }}>
              {Number(row.balance || 0).toFixed(2)}
            </td>
          </tr>
        ))}

        <tr className="ledger-total-row">
          <td colSpan={2} style={{ textAlign: "right" }}>
            Grand Total
          </td>

          <td style={{ textAlign: "right" }}>
            {openingTotal.toFixed(2)}
          </td>

          <td style={{ textAlign: "right" }}>
            {assetTotal.toFixed(2)}
          </td>

          <td style={{ textAlign: "right" }}>
            {depreciationTotal.toFixed(2)}
          </td>

          <td style={{ textAlign: "right" }}>
            {Number(total_balance || 0).toFixed(2)}
          </td>
        </tr>
      </tbody>
    </table>
  );
}

  return (
    <Table
      rowKey={(row, idx) => idx}
      columns={columns}
      dataSource={list}
      loading={loading}
      pagination={
        printMode
          ? false
          : {
              ...pagination,
              showSizeChanger: true,
              pageSizeOptions: ["10", "20", "50"],
            }
      }
      onChange={handleTableChange}
      bordered
      scroll={printMode ? undefined : { x: "max-content" }}
      summary={() => {
        if (!list.length) return null;
        return (
          <Table.Summary.Row>
            <Table.Summary.Cell index={0} colSpan={2} align="right">
              Grand Total:
            </Table.Summary.Cell>
            <Table.Summary.Cell index={2} align="right">
              {_.sumBy(list, (acc) => Number(acc.opening_balance)).toFixed(2)}
            </Table.Summary.Cell>
            <Table.Summary.Cell index={3} align="right">
              {_.sumBy(list, (acc) => Number(acc.payment_total)).toFixed(2)}
            </Table.Summary.Cell>
            <Table.Summary.Cell index={4} align="right">
              {_.sumBy(list, (acc) => Number(acc.received_total)).toFixed(2)}
            </Table.Summary.Cell>
            <Table.Summary.Cell index={5} align="right">
              {total_balance.toFixed(2)}
            </Table.Summary.Cell>
          </Table.Summary.Row>
        );
      }}
    />
  );
};

export default FixedAssetBalanceTable;
